import React from 'react';
import { Wrapper, Content, Controls, Title, ProductCount, Description, StyledLink, Name } from './card-catalog.styles';
import { CardCatalogProps } from './types';
import { Typography } from '@shared/ui/typography/typography';
import { ROUTE_ADMIN_CATALOGS } from '@shared/config/routes/routes';

export const CardCatalog: React.FC<CardCatalogProps> = ({ catalog, children, ...props }) => {
    return (
        <Wrapper {...props}>
            <StyledLink to={`${ROUTE_ADMIN_CATALOGS}/${catalog.id}`}>
                <Content>
                    <Title>
                        <Name size='h6' color='neutral_90'>
                            {catalog.name}
                        </Name>
                        <ProductCount>
                            <Typography size='body2_short' color='neutral_90'>
                                {catalog.productCount}
                            </Typography>
                        </ProductCount>
                    </Title>
                    <Description size='body2_long' color='neutral_50'>
                        {catalog.description}
                    </Description>
                </Content>
            </StyledLink>
            <Controls>{children}</Controls>
        </Wrapper>
    );
};
